import { Searcher } from 'fast-fuzzy';

const ABBREVIATIONS = {
	france: { av: 'avenue', ave: 'avenue', bd: 'boulevard', bvd: 'boulevard', r: 'rue', imp: 'impasse', all: 'allee', chem: 'chemin', pl: 'place', rte: 'route', st: 'saint', ste: 'sainte', sq: 'square' },
	england: { st: 'street', rd: 'road', ave: 'avenue', av: 'avenue', ln: 'lane', dr: 'drive', ct: 'court', blvd: 'boulevard', sq: 'square' },
	spain: { c: 'calle', cl: 'calle', av: 'avenida', avda: 'avenida', pza: 'plaza', pl: 'plaza', ctra: 'carretera', pso: 'paseo', ps: 'paseo' },
	portugal: { r: 'rua', av: 'avenida', pc: 'praca', tv: 'travessa', est: 'estrada', lg: 'largo' },
	germany: { str: 'strasse', pl: 'platz', w: 'Weg' },
	netherlands: { str: 'straat', ln: 'laan', pl: 'plein' },
};

const strip = (value, country) => {
	const abbreviations = ABBREVIATIONS[country] ?? {};
	return String(value ?? '')
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
		.replace(/ß/g, 'ss')
		.replace(/[^\p{L}\p{N}\s]/gu, ' ')
		.split(/\s+/)
		.filter(Boolean)
		.map((token) => abbreviations[token] ?? token)
		.join(' ')
		.trim();
};
const numbers = (s) => (s.match(/\d+/g) ?? []).join(',');

const buildKey = (dl) => {
	const country = dl.country?.toLowerCase();
	const address = strip(dl.addressLine, country);
	return { address, key: `${address} ${strip(dl.city, country)}`.trim() };
};

export function createAddressMatcher(locations, { threshold = 0.85 } = {}) {
	const searcher = new Searcher(
		locations.map((dl) => {
			const { address, key } = buildKey(dl);
			return { ...dl, _address: address, _key: key };
		}),
		{ keySelector: (dl) => dl._key, threshold, useSellers: false, returnMatchData: true }
	);

	return (candidate) => {
		const { address, key } = buildKey(candidate);
		if (address.length < 5) return null;
		const postcode = strip(candidate.postcode, candidate.country?.toLowerCase());
		return (
			searcher
				.search(key)
				.filter(({ item }) => strip(item.postcode, item.country?.toLowerCase()) === postcode)
				.at(0)?.item ?? null
		);
	};
}

/*
item.deliveryLocationTypeId === candidate.deliveryLocationTypeId
					&& strip(item.postcode, item.country?.toLowerCase()) === postcode
					&& numbers(item._address) === numbers(address))*/
